import { useDispatch } from 'react-redux';
import { useState } from 'react';
import {
  NOTIFICATION_LEVEL_ERROR,
  NOTIFICATION_LEVEL_SUCCESS,
} from '@avtechsoftware/ra-javascript-utilities/src/types/NotificationLevels';
import { pushSessionMessage } from '../../../redux/slices/toastNotificationSlice/toastNotificationSlice';
import envConfig from '../../../envConfig';
import { fetchNotificationGroups } from '../../../redux/slices/notificationGroupsSlice/notificationGroupsSlice';

const useNotificationGroupUpdater = () => {
  const dispatch = useDispatch();
  const [isFormSubmitting, setIsFormSubmitting] = useState(false);
  const [submitBtnText, setSubmitBtnText] = useState('Save Changes');

  const handleCreateNotificationGroupSuccess = () => {
    dispatch(pushSessionMessage({
      level: NOTIFICATION_LEVEL_SUCCESS,
      title: 'Saved',
      body: 'Notification group saved successfully.',
    }));
    setIsFormSubmitting(false);
    setSubmitBtnText('Save Changes');
    window.location.assign(`${envConfig.raaUrl}/s/actions/notification-groups`);
  };

  const handleCreateNotificationGroupFailure = () => {
    dispatch(fetchNotificationGroups());
    dispatch(pushSessionMessage({
      level: NOTIFICATION_LEVEL_ERROR,
      title: 'Save Error',
      body: 'Error saving notification group.',
    }));
    setIsFormSubmitting(false);
    setSubmitBtnText('Save Changes');
  };

  const handleUpdateNotificationGroupSuccess = () => {
    dispatch(pushSessionMessage({
      level: NOTIFICATION_LEVEL_SUCCESS,
      title: 'Saved',
      body: 'Notification group edited successfully.',
    }));
    setIsFormSubmitting(false);
    setSubmitBtnText('Save Changes');
    window.location.assign(`${envConfig.raaUrl}/s/actions/notification-groups`);
  };

  const handleUpdateNotificationGroupFailure = () => {
    dispatch(pushSessionMessage({
      level: NOTIFICATION_LEVEL_ERROR,
      title: 'Save Error',
      body: 'Error editing notification group.',
    }));
    setIsFormSubmitting(false);
    setSubmitBtnText('Save Changes');
  };

  return {
    handleCreateNotificationGroupSuccess,
    handleCreateNotificationGroupFailure,
    handleUpdateNotificationGroupSuccess,
    handleUpdateNotificationGroupFailure,
    setIsFormSubmitting,
    isFormSubmitting,
    setSubmitBtnText,
    submitBtnText,
  };
};

export default useNotificationGroupUpdater;
